import { render, staticRenderFns } from "./AssignationItem.vue?vue&type=template&id=5585c3e8&scoped=true&"
import script from "./AssignationItem.vue?vue&type=script&lang=js&"
export * from "./AssignationItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignationItem.vue?vue&type=style&index=0&id=5585c3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585c3e8",
  null
  
)

export default component.exports